var base = require('core/components/countrySelector');

/**
 * Get cookie value by cookie name from browser
 * @param {string} cookieName - name of the cookie
 * @returns {string} cookie value of the found cookie name
 */
function getCookie(cookieName) {
    var name = cookieName + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookieArray = decodedCookie.split(';');
    for (var i = 0; i < cookieArray.length; i++) {
        var cookieItem = cookieArray[i];
        while (cookieItem.charAt(0) === ' ') {
            cookieItem = cookieItem.substring(1);
        }
        if (cookieItem.indexOf(name) === 0) {
            return cookieItem.substring(name.length, cookieItem.length);
        }
    }
    return '';
}

/**
 * Sets a cookie in the browser with a specified name, value, and expiration time in days.
 * @param {string} cookieName - The name of the cookie to set.
 * @param {string} cookieValue - The value to store in the cookie.
 * @param {number} days - The number of days until the cookie expires.
 * @return {void}
 */
function setCookie(cookieName, cookieValue, days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    var expires = 'expires=' + date.toUTCString();
    document.cookie = cookieName + '=' + cookieValue + ';' + expires + ';path=/';
}

module.exports = function () {
    var cookie = getCookie('autobahn_country_selector');
    if (cookie === 'show') {
        setCookie('autobahn_country_selector', 'do_not_show', 30);
        $('#countrySelectorModal').modal('show');
    }

    return base.apply(this, arguments);
};